import { all } from 'redux-saga/effects';

import companyAssetSaga from './company-asset-saga';

export default function* rootSaga() {
  yield all([companyAssetSaga()]);
}
